import { API_V1_PREFIX, API_V2_PREFIX } from '../shared/api.constants';

export const LADELOESUNG_PATH_PREFIX = '/ladeloesung';

// Card Endpoints
const CARD_PATH_PREFIX = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/card`;
export const CARDS_V2_ENDPOINT = `${API_V2_PREFIX}${LADELOESUNG_PATH_PREFIX}/cards`;
export const CARDS_RELEVANT_FOR_TARIFF_RENEWAL_ENDPOINT = `${API_V2_PREFIX}${LADELOESUNG_PATH_PREFIX}/cards/relevant-for-tariff-renewal`;
export const CARDS_RELEVANT_FOR_TARIFF_SWITCH_ENDPOINT = `${API_V2_PREFIX}${LADELOESUNG_PATH_PREFIX}/cards/relevant-for-tariff-switch`;

export const CARD_DETAILS_ENDPOINT = (cardNr: string) =>
  `${API_V2_PREFIX}${LADELOESUNG_PATH_PREFIX}/cards/${cardNr}/details`;

export const CARD_ACTIVATE_ENDPOINT = (contractId: string) =>
  `${CARD_PATH_PREFIX}/${contractId}/activate`;
export const CARD_LOCK_ENDPOINT = (contractId: string) =>
  `${CARD_PATH_PREFIX}/${contractId}/lock`;
export const CARD_UNLOCK_ENDPOINT = (contractId: string) =>
  `${CARD_PATH_PREFIX}/${contractId}/unlock`;
export const CARD_UPDATE_ENDPOINT = (contractId: string) =>
  `${CARD_PATH_PREFIX}/${contractId}`;

export const CARD_ORDER_V2_ENDPOINT = `${API_V2_PREFIX}${LADELOESUNG_PATH_PREFIX}/card/order`;

// Customer Endpoints
const CUSTOMER_DATA_PATH_PREFIX = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/customer`;
export const CUSTOMER_DATA_ENDPOINT = CUSTOMER_DATA_PATH_PREFIX;
export const CUSTOMER_COMPANY_ENDPOINT = `${CUSTOMER_DATA_PATH_PREFIX}/company`;
export const CUSTOMER_SHIPPING_ADDRESS_ENDPOINT = `${CUSTOMER_DATA_PATH_PREFIX}/shipping-address`;
export const CUSTOMER_PAYMENT_DETAILS_ENDPOINT = `${CUSTOMER_DATA_PATH_PREFIX}/payment-details`;

// Charging Session Endpoints
export const CHARGING_SESSIONS_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/charging-sessions`;

// Invoice Endpoints
const INVOICE_PATH_PREFIX = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/invoices`;
export const INVOICES_ENDPOINT = `${INVOICE_PATH_PREFIX}`;
export const DOWNLOAD_INVOICE_ENDPOINT = (invoiceNumber: string) =>
  `${INVOICE_PATH_PREFIX}/${invoiceNumber}/download`;

// Charging Station Endpoints
const PUBLIC_FAVORITES_PATH_PREFIX = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/public/favorites`;
export const PUBLIC_FAVORITES_ENDPOINT = PUBLIC_FAVORITES_PATH_PREFIX;
export const ADD_PUBLIC_LOCATION_TO_FAVORITES_ENDPOINT = (locationId: string) =>
  `${PUBLIC_FAVORITES_PATH_PREFIX}/${locationId}`;
export const REMOVE_PUBLIC_LOCATION_FROM_FAVORITES_ENDPOINT = (locationId: string) =>
  `${PUBLIC_FAVORITES_PATH_PREFIX}/${locationId}`;
export const PUBLIC_LOCATIONS_IN_RADIUS_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/public/locations-in-radius`;
export const AUTOCOMPLETE_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/autocomplete`;
export const LOCATIONS_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/locations`;

// Tariffs
export const TARIFFS_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/tariffs`;
export const TARIFF_ORDER_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/tariff/order`;
export const TARIFF_SWITCH_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/tariff/switch`;
export const TARIFF_TERMINATE_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/tariff/terminate`;
// Link Resources Endpoints
export const LINK_RESOURCES_ENDPOINT = `${API_V1_PREFIX}${LADELOESUNG_PATH_PREFIX}/link-resources`;

